var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.purchType == 1 || _vm.purchType == 3,
            expression: "purchType == 1 || purchType == 3"
          }
        ]
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "simple-row" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "a",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.showGoodsListDlg()
                  }
                }
              },
              [_vm._v("添加商品")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            !_vm.lowCostFlag
              ? _c("span", { staticClass: "mr10" }, [
                  _vm._v(
                    "含税总金额(元)：" +
                      _vm._s(
                        parseFloat(
                          _vm.deviceRequireVoucher.wtxAmount || 0
                        ).toFixed(2)
                      )
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.lowCostFlag
              ? _c("span", [
                  _vm._v(
                    "包含组装件总数：" + _vm._s(_vm.totalAsmblAccSetCount || 0)
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "goodsItemList",
            staticClass: "demo-ruleForm",
            attrs: { model: _vm.deviceRequireVoucher }
          },
          [
            _c("div", { staticClass: "table-layout" }, [
              _c(
                "div",
                {
                  staticClass: "table-layout",
                  staticStyle: { "overflow-x": "auto" }
                },
                [
                  _c(
                    "table",
                    { staticClass: "custom-tbl" },
                    [
                      _c("thead", { staticClass: "head" }, [
                        _c("tr", { staticClass: "row" }, [
                          _c("th", { attrs: { width: "60" } }, [
                            _vm._v("序号")
                          ]),
                          _vm._v(" "),
                          _vm.showAssetInfo
                            ? _c(
                                "th",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { width: "180" }
                                },
                                [_vm._v("资产定义编码")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showAssetInfo
                            ? _c(
                                "th",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { width: "180" }
                                },
                                [_vm._v("资产描述全称")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showAssetInfo
                            ? _c(
                                "th",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { width: "120" }
                                },
                                [_vm._v("型号")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showAssetInfo
                            ? _c(
                                "th",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { width: "120" }
                                },
                                [_vm._v("规格")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showAssetInfo
                            ? _c(
                                "th",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { width: "120" }
                                },
                                [_vm._v("品牌")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { width: "180" }
                            },
                            [_vm._v("名称")]
                          ),
                          _vm._v(" "),
                          _vm.showAssetInfo
                            ? _c(
                                "th",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { width: "120" }
                                },
                                [_vm._v("资产分类名称")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { width: "120" }
                            },
                            [_vm._v("分类名称")]
                          ),
                          _vm._v(" "),
                          !_vm.showAssetInfo
                            ? _c(
                                "th",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { width: "120" }
                                },
                                [_vm._v("品牌名称")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.showAssetInfo
                            ? _c(
                                "th",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { width: "120" }
                                },
                                [_vm._v("型号")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.showAssetInfo
                            ? _c(
                                "th",
                                {
                                  staticStyle: { "text-align": "left" },
                                  attrs: { width: "120" }
                                },
                                [_vm._v("规格")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "60" } }, [
                            _vm._v("单位")
                          ]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { width: "180" }
                            },
                            [_vm._v("供应商")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { width: "180" }
                            },
                            [_vm._v("供方公司")]
                          ),
                          _vm._v(" "),
                          !_vm.lowCostFlag && !_vm.onlyForAsmblAcc
                            ? _c("th", { attrs: { width: "80" } }, [
                                _vm._v("仅组装件")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "80" } }, [
                            _vm._v("采购模式")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "80" } }, [
                            _vm._v("是否定制")
                          ]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "right" },
                              attrs: { width: "110" }
                            },
                            [_vm._v("含税价(元)")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "right" },
                              attrs: { width: "110" }
                            },
                            [_vm._v("含税小计(元)")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "right" },
                              attrs: { width: "90" }
                            },
                            [_vm._v("税率(%)")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "right" },
                              attrs: { width: "110" }
                            },
                            [_vm._v("未税价(元)")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "right" },
                              attrs: { width: "110" }
                            },
                            [_vm._v("包含组装件数量")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "right" },
                              attrs: { width: "100" }
                            },
                            [_vm._v("申请数量")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticStyle: { "text-align": "left" },
                              attrs: { width: "180" }
                            },
                            [_vm._v("操作")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.deviceRequireVoucher.goodsItemList, function(
                        goodsItem,
                        index
                      ) {
                        return _c(
                          "tbody",
                          { staticClass: "body" },
                          [
                            _c("tr", { staticClass: "row" }, [
                              _c(
                                "td",
                                {
                                  attrs: {
                                    rowspan: goodsItem.itemList.length + 1
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(index + 1))])]
                              ),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(goodsItem.assetDefNo || "")
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(goodsItem.devcTitle || "")
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(goodsItem.devcModel || "")
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(goodsItem.devcFixedSpec || "")
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(goodsItem.devcBrandName || "")
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _vm.showAssetInfo
                                    ? _c("span", [
                                        _vm._v(_vm._s(goodsItem.devcName || ""))
                                      ])
                                    : _c("span", [
                                        _vm._v(_vm._s(goodsItem.name || ""))
                                      ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            goodsItem.innerDevcCatName || ""
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(goodsItem.goodsCatName || ""))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(goodsItem.goodsBrandName || "")
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(goodsItem.model || ""))
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(goodsItem.fixedSpec || "")
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [
                                _vm.showAssetInfo
                                  ? _c("span", [
                                      _vm._v(_vm._s(goodsItem.devcUnit || ""))
                                    ])
                                  : _c("span", [
                                      _vm._v(_vm._s(goodsItem.unit || ""))
                                    ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(goodsItem.vendorName || ""))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(goodsItem.vendorRealComName || "")
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.lowCostFlag && !_vm.onlyForAsmblAcc
                                ? _c("td", [
                                    _c("span", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: goodsItem.onlyForAsmblAcc,
                                            expression:
                                              "goodsItem.onlyForAsmblAcc"
                                          }
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          disabled:
                                            _vm.onlyForAsmblAcc ||
                                            goodsItem.deviceId == -1
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            goodsItem.onlyForAsmblAcc
                                          )
                                            ? _vm._i(
                                                goodsItem.onlyForAsmblAcc,
                                                null
                                              ) > -1
                                            : goodsItem.onlyForAsmblAcc
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$a =
                                                  goodsItem.onlyForAsmblAcc,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      goodsItem,
                                                      "onlyForAsmblAcc",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      goodsItem,
                                                      "onlyForAsmblAcc",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  goodsItem,
                                                  "onlyForAsmblAcc",
                                                  $$c
                                                )
                                              }
                                            },
                                            function($event) {
                                              _vm.onlyForAsmblAccChange(
                                                index,
                                                goodsItem.onlyForAsmblAcc
                                              )
                                            }
                                          ]
                                        }
                                      })
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [
                                goodsItem.onlyForAsmblAcc && _vm.audoAuditorFlag
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "请选择" },
                                            on: {
                                              change: function($event) {
                                                _vm.selectCentBuyMode(index)
                                              }
                                            },
                                            model: {
                                              value: goodsItem.centBuyMode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  goodsItem,
                                                  "centBuyMode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "goodsItem.centBuyMode"
                                            }
                                          },
                                          _vm._l(_vm.centBuyModeList, function(
                                            item
                                          ) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.text,
                                                value: item.value
                                              }
                                            })
                                          })
                                        )
                                      ],
                                      1
                                    )
                                  : _c("span", [
                                      goodsItem.centBuyMode
                                        ? _c("span", [_vm._v("集采")])
                                        : _c("span", [_vm._v("自采")])
                                    ])
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(goodsItem.customized ? "是" : "否")
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  !goodsItem.customized
                                    ? [
                                        goodsItem.price != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  goodsItem.price.toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    : [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "goodsItemList." +
                                                index +
                                                ".price"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: { type: "number" },
                                              on: {
                                                change: function($event) {
                                                  _vm.changeGoodsPrice(
                                                    index,
                                                    goodsItem.price,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value: goodsItem.price,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    goodsItem,
                                                    "price",
                                                    $$v
                                                  )
                                                },
                                                expression: "goodsItem.price"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  goodsItem.wtxAmount != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            parseFloat(
                                              goodsItem.wtxAmount
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  goodsItem.taxRate != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(goodsItem.taxRate.toFixed(2))
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  !goodsItem.customized
                                    ? [
                                        goodsItem.ntxPrice != null
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  goodsItem.ntxPrice.toFixed(2)
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ]
                                    : [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "goodsItemList." +
                                                index +
                                                ".ntxPrice"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "number",
                                                disabled: ""
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.changeGoodsPrice(
                                                    index,
                                                    goodsItem.price,
                                                    false
                                                  )
                                                }
                                              },
                                              model: {
                                                value: goodsItem.ntxPrice,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    goodsItem,
                                                    "ntxPrice",
                                                    $$v
                                                  )
                                                },
                                                expression: "goodsItem.ntxPrice"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(goodsItem.asmblAccSetCount || 0)
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "goodsItemList." + index + ".quantity"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "text",
                                          disabled:
                                            goodsItem.onlyForAsmblAcc ||
                                            goodsItem.customized
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.goodsQuantity(
                                              index,
                                              goodsItem.quantity
                                            )
                                          }
                                        },
                                        model: {
                                          value: goodsItem.quantity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              goodsItem,
                                              "quantity",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "goodsItem.quantity"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.removeGoods(index)
                                        }
                                      }
                                    },
                                    [_vm._v("移除")]
                                  ),
                                  _vm._v(" "),
                                  goodsItem.skuId == -1 &&
                                  goodsItem.deviceId != -1
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.addAdoptedGoods(index)
                                            }
                                          }
                                        },
                                        [_vm._v("关联供方商品")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.lowCostFlag && goodsItem.deviceId != -1
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.addAsmblAcc(index)
                                            }
                                          }
                                        },
                                        [_vm._v("添加组装件")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.lowCostFlag && goodsItem.deviceId == -1
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.addAsmblAccForVirtual(index)
                                            }
                                          }
                                        },
                                        [_vm._v("添加组装件")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(goodsItem.itemList, function(
                              asmblAccItem,
                              itemIndex
                            ) {
                              return _c("tr", { staticClass: "row" }, [
                                _vm.showAssetInfo
                                  ? _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(asmblAccItem.accDefNo || "")
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showAssetInfo
                                  ? _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(asmblAccItem.devcTitle || "")
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showAssetInfo
                                  ? _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(asmblAccItem.devcModel || "")
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showAssetInfo
                                  ? _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              asmblAccItem.devcFixedSpec || ""
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showAssetInfo
                                  ? _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              asmblAccItem.devcBrandName || ""
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _vm.showAssetInfo
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(asmblAccItem.devcName || "")
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(asmblAccItem.name || "")
                                          )
                                        ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.showAssetInfo
                                  ? _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              asmblAccItem.innerDevcCatName ||
                                                ""
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(asmblAccItem.goodsCatName || "")
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.showAssetInfo
                                  ? _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              asmblAccItem.goodsBrandName || ""
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.showAssetInfo
                                  ? _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(asmblAccItem.model || "")
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.showAssetInfo
                                  ? _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(asmblAccItem.fixedSpec || "")
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("td", [
                                  _vm.showAssetInfo
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(asmblAccItem.devcUnit || "")
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(_vm._s(asmblAccItem.unit || ""))
                                      ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(asmblAccItem.vendorName || "")
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          asmblAccItem.vendorRealComName || ""
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.lowCostFlag && !_vm.onlyForAsmblAcc
                                  ? _c("td", [_c("span")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("td", [_c("span")]),
                                _vm._v(" "),
                                _c("td", [_c("span")]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    asmblAccItem.price != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              asmblAccItem.price.toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    asmblAccItem.wtxAmount != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              parseFloat(
                                                asmblAccItem.wtxAmount
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    asmblAccItem.taxRate != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              asmblAccItem.taxRate.toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    asmblAccItem.ntxPrice != null
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              asmblAccItem.ntxPrice.toFixed(2)
                                            )
                                          )
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "goodsItemList." +
                                            index +
                                            ".itemList." +
                                            itemIndex +
                                            ".quantity",
                                          rules: {
                                            validator: _vm.validateQuantity,
                                            trigger: "blur"
                                          }
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { type: "text" },
                                          on: {
                                            change: function($event) {
                                              _vm.accQuantity(itemIndex, index)
                                            }
                                          },
                                          model: {
                                            value: asmblAccItem.quantity,
                                            callback: function($$v) {
                                              _vm.$set(
                                                asmblAccItem,
                                                "quantity",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "asmblAccItem.quantity"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "swb-btn-link",
                                        on: {
                                          click: function($event) {
                                            _vm.removeAccGoods(itemIndex, index)
                                          }
                                        }
                                      },
                                      [_vm._v("移除")]
                                    ),
                                    _vm._v(" "),
                                    asmblAccItem.skuId == null ||
                                    asmblAccItem.skuId == -1
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "swb-btn-link",
                                            on: {
                                              click: function($event) {
                                                _vm.addAccSku(itemIndex, index)
                                              }
                                            }
                                          },
                                          [_vm._v("生成入选商品")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "swb-btn-link",
                                        on: {
                                          click: function($event) {
                                            _vm.selectAdoptedGoods(
                                              itemIndex,
                                              index
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("关联入选商品")]
                                    )
                                  ]
                                )
                              ])
                            })
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      _vm.deviceRequireVoucher.goodsItemList == null ||
                      _vm.deviceRequireVoucher.goodsItemList.length <= 0
                        ? _c("tbody", { staticClass: "body" }, [
                            _c("tr", { staticClass: "row" }, [
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "line-height": "40px"
                                  },
                                  attrs: { colspan: "16" }
                                },
                                [_c("span", [_vm._v("暂无数据...")])]
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.purchType == 2 || _vm.purchType == 3,
            expression: "purchType == 2 || purchType == 3"
          }
        ]
      },
      [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "simple-row" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "a",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.showServcListDlg()
                  }
                }
              },
              [_vm._v("添加服务")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "servcItemList",
            staticClass: "demo-ruleForm",
            attrs: { model: _vm.deviceRequireVoucher }
          },
          [
            _c(
              "div",
              { staticClass: "table-layout" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      border: "",
                      data: _vm.deviceRequireVoucher.servcItemList,
                      maxHeight: "500"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        "min-width": "300",
                        align: "left",
                        prop: "name",
                        label: "名称"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "200",
                        prop: "servcCatName",
                        label: "分类名称"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "200",
                        prop: "servcBrandName",
                        label: "品牌名称"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "fixedSpec",
                        label: "规格",
                        width: "200"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "desc",
                        label: "描述",
                        width: "300"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "servcItemList." + scope.$index + ".desc"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "width-1.5x",
                                    attrs: {
                                      type: "textarea",
                                      rows: 2,
                                      placeholder: "请输入内容"
                                    },
                                    model: {
                                      value: scope.row.desc,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "desc", $$v)
                                      },
                                      expression: "scope.row.desc"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "unit",
                        label: "单位",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "left", label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.removeServc(scope.$index)
                                    }
                                  }
                                },
                                [_vm._v("移除")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "swb-btn swb-btn-small",
        on: {
          click: function($event) {
            _vm.showDialogFile()
          }
        }
      },
      [_vm._v("上传")]
    ),
    _vm._v(" "),
    _vm.deviceRequireVoucher.deviceRequireFileList != null &&
    _vm.deviceRequireVoucher.deviceRequireFileList.length > 0
      ? _c(
          "div",
          { staticClass: "file-view-list" },
          [
            _vm._m(3),
            _vm._v(" "),
            _vm._l(_vm.deviceRequireVoucher.deviceRequireFileList, function(
              fileInfo,
              index
            ) {
              return [
                _c("swb-file-item-li", {
                  attrs: {
                    trackKey: index,
                    fileName: fileInfo.name,
                    fileBrowseUrl: fileInfo.fileBrowseUrl,
                    fileDownloadUrl: fileInfo.fileBrowseUrl,
                    fileUuid: fileInfo.fileUuid,
                    deletable: true,
                    onDelete: _vm.deleteFile
                  }
                })
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("请购商品")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("请购服务")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("附件信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-view-header" }, [
      _c("div", { staticClass: "file-name" }, [_vm._v("名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "file-opera" }, [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1105e1dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1105e1dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/CreateRequireItem.vue
// module id = 2903
// module chunks = 0